import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { takeEvery } = sagaEffects;

function* handler() {
    const firestore = getFirestore(getFirebase());
    try {
        yield firestore.unsetListener({
            collection: `imports`,
            storeAs: 'lastImport',
            orderBy: ['startAt', 'desc'],
            limit: 1,
        });
    } catch (e) {
        loglevel.error(e);
    }
}

export default function* () {
    yield takeEvery(types.UNLISTEN_LAST_IMPORT, handler);
}
